import { request, requestFile, queryString } from '../util'

const headers = { 'Content-Type': 'application/json' }
const url = '/private/api/export/payroll'

export default {
  getPayrollExport (type, values) {
    return requestFile(`${url}/${type}`, {
      method: 'POST',
      headers,
      body: JSON.stringify(values)
    })
  },
}
